module.exports = __webpack_public_path__ + "static/img/VOLVO.bebe877.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/VOLVO.png
// module id = bVxR
// module chunks = 1